<template>
    <div class="tsa-Agreement" v-show="show">
        <div class="mask" @touchmove.prevent></div>
        <div class="content">
            <div class="tsa-Agreement-title">
                <span>{{ title || '数字证书服务协议'}}</span>
            </div>
            <div class="container">
                <!-- <iframe :src="url" frameborder="0"></iframe> -->
                <div id="tsaPdfContainer"></div>
            </div>
            <div class="btgGroup">
                <a class="cancel" href="javascript:;" @click="disagree">
                    <span>取消</span>
                </a>
                <a class="confirm" href="javascript:;" @click="agree">
                    <span>我已阅读并同意</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import Pdfh5 from "pdfh5";
import 'pdfh5/css/pdfh5.css'
export default {
    name: 'tsa-Agreement',
    data () {
        return {
            show: false,
            title: '',
            url: '',
            statusConfirm: 0,
            statusCancel: 0,
            pdfh5: null,
        }
    },
    watch: {
        show (val) {
            if (val) {
                this.pdfh5 = new Pdfh5("#tsaPdfContainer", {
                    pdfurl: this.url
                });
            } else {
                this.pdfh5.destroy()
                this.pdfh5 = null
            }
        }
    },
    methods: {
        disagree () {
            this.statusCancel++
        },
        agree () {
            this.statusConfirm++
        }
    }
}
</script>

<style scoped>
    .tsa-Agreement {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        z-index: 10;
    }
    .mask {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: rgba(0,0,0,0.6);
        
    }
    .content {
        position: absolute;
        width: 90%;
        height: 80%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #fff;
        display: flex;
        flex-direction: column;
        border-radius: 4px;
    }
    .tsa-Agreement-title {
        height: 44px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid #ddd;
       
    }
    .tsa-Agreement-title span {
        font-size: 16px;
        font-weight: bold;
    }
    .container {
        overflow: hidden;
        flex: 1;
    }
    .container iframe {
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
    }
    .btgGroup {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        border-top: 1px solid #ddd;
    }
    .btgGroup a {
        height: 44px;
        flex: 1;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .btgGroup a span {
        color: #26a2ff;
    }
    .btgGroup .cancel {
        border-right: 1px solid #ddd;
    }
    .btgGroup .confirm {
        
    }
</style>


// WEBPACK FOOTER //
// src/components/Agreement/index.vue